import { store } from '../store';
import {createApp} from 'vue';
import {sendPetition} from './scripts';
import countriesCA from '../../assets/data/paisos_ca.json'

if(document.querySelector('.p-checkout-module')){
	var app_courses_module = createApp({
		data(){
			return {
				checkoutComplete: false,
				tab: 0,			// 0: collegiat / 1: non-collegiat
				//clientLogged: false,
				loginData: {
					code: "",
					pass: ""
				},
				loginErrors: {
					userNotFound: false,
					passwordError: false
				},
				loadingLogin: false,
				loadingFinal:false,
				clientDataLogged:{
					name: "",
					surname: "",
					documentType: "",
					documentNumber: "",
					phone: "",
					email: "",
					companyName: "",
					companyProfessionalActivity: "",
					companyProfessionalActivityString: "",
					companyRole: "",
					companyRoleString: ""
				},
				billingDataLogged:{
					name: "",
					surname: "",
					documentType: "",
					documentNumber: "",
					address: "",
					zipcode: "",
					city: "",
					countryISO: "",
					country: "",


					companyName: "",
					companyCIF: ""
				},
				clientDataLoggedError:{
					name: false,
					surname: false,
					documentType: false,
					documentNumber: false,
					phone: false,
					email: false,
					companyName: false,
					companyProfessionalActivity: false,
					companyRole: false
				},
				billingDataLoggedError:{
					name: false,
					surname: false,
					documentType: false,
					documentNumber: false,
					address: false,
					zipcode: false,
					city: false,
					country: false,


					companyName: false,
					companyCIF: false
				},
				clientDataLoggedSuccess:{
					name: false,
					surname: false,
					documentType: false,
					documentNumber: false,
					phone: false,
					email: false,
					companyName: false,
					companyProfessionalActivity: false,
					companyRole: false
				},
				billingDataLoggedSuccess:{
					name: false,
					surname: false,
					documentType: false,
					documentNumber: false,
					address: false,
					zipcode: false,
					city: false,
					country: false,


					companyName: false,
					companyCIF: false
				},
				clientDataUnlogged:{
					name: "",
					surname: "",
					documentNumber: "",
					documentType: "",
					phone: "",
					email: "",
					companyName: "",
					companyProfessionalActivity: "",
					companyProfessionalActivityString: "",
					companyRole: "",
					companyRoleString: ""
				},
				billingDataUnlogged:{
					name: "",
					surname: "",
					documentType: "",
					documentNumber: "",
					address: "",
					zipcode: "",
					city: "",
					country: "",
					countryISO: "",


					companyName: "",
					companyCIF: ""
				},
				clientDataUnloggedError:{
					name: false,
					surname: false,
					documentType: false,
					documentNumber: false,
					phone: false,
					email: false,
					companyName: false,
					companyProfessionalActivity: false,
					companyRole: false
				},
				billingDataUnloggedError:{
					name: false,
					surname: false,
					documentType: false,
					documentNumber: false,
					address: false,
					zipcode: false,
					city: false,
					country: false,


					companyName: false,
					companyCIF: false
				},
				clientDataUnloggedSuccess:{
					name: false,
					surname: false,
					documentType: false,
					documentNumber: false,
					phone: false,
					email: false,
					companyName: false,
					companyProfessionalActivity: false,
					companyRole: false
				},
				billingDataUnloggedSuccess:{
					name: false,
					surname: false,
					documentType: false,
					documentNumber: false,
					address: false,
					zipcode: false,
					city: false,
					country: false,


					companyName: false,
					companyCIF: false
				},
				pickupDataLogged:{
					location: ""
				},
				pickupDataUnlogged:{
					location: ""
				},
				pickupDataLoggedError:{
					location: false
				},
				pickupDataUnloggedError:{
					location: false
				},
				pickupDataLoggedSuccess:{
					location: false
				},
				pickupDataUnloggedSuccess:{
					location: false
				},
				paymentMethodLogged: "J",
				paymentMethodUnlogged: "J",
				conditionsCheckedLogged: false,
				conditionsCheckedUnlogged: false,

				payerLoggedIsCompany:false,
				payerUnloggedIsCompany: false,
				clientLoggedIsCompany: false,
				clientUnloggedIsCompany: false,

				products:[],
				product_type: "",
				selected_product_id:[],
				discounts: [],
				productName: "",
				productTag: "",
				imgUrl: "",
				infoLinkUrl: "#",
				fullPrice: 0,
				intercolPrice:0,
				collegiatPrice: 0,
				finalPrice: 0,
				isFree: false,
				needsPickup: false,
				selectedDiscount: null,
				outputURLComplete: "",
				outputURLError: "",
				countriesList: countriesCA,
			}
		},
		computed: {
			clientLogged(){
				return store.getters['account/clientLogged']
			},
			sessionInfo(){
				return store.getters['account/sessionInfo']
			}
		},
		watch: {
			clientLogged: function(){
				this.calculateFinalPrice();
			},
			sessionInfo: function(){
				switch (this.sessionInfo.result.statusCode) {
					case 200:
						this.fillLoggedData();
						this.loadingLogin = false;
						break;
					case 401:
						console.log('User Error')
						this.loadingLogin = false;
						this.loginErrors.userNotFound = true;
						break;
					case 500:
						//this.fillLoggedData();
						this.loadingLogin = false;
						console.log('Password Error')
						this.loginErrors.passwordError = true;
						//store.dispatch('account/forceLogin');
						break;

					default:
						break;
				}
			}
		},
		mounted(){
			console.log('initializing checkout page');
			//console.log(countriesCA)
			//this.product_type = wp_js_var.checkout_product_type;
			this.product_type = sessionStorage.getItem('checkoutProductsType');
			this.products = JSON.parse(sessionStorage.getItem('checkoutProducts'));
			/* console.log(sessionStorage.getItem('checkoutProductsType'));
			console.log(this.products); */
			sessionStorage.setItem('errorCode', 0)
			//console.log(this.products);
			if(this.product_type == 'course' || this.product_type == 'activity'){
				//console.log(this.products[0].id);
				this.productName = this.products[0].title;
				this.productTag = this.products[0].tag;
				this.imgUrl = this.products[0].img;
				this.infoLinkUrl = this.products[0].url;
				if (this.products[0].fullPrice!="") {
					this.fullPrice = this.products[0].fullPrice.replace('€', '');
				}else{
					this.fullPrice = 0.00;
				}
				if (this.products[0].interPrice && this.products[0].interPrice != "") {
					this.intercolPrice = this.products[0].interPrice.replace('€', '');
				}else{
					this.intercolPrice = 0.00;
				}
				if (this.products[0].collegiatPrice != "") {
					this.collegiatPrice = this.products[0].collegiatPrice.replace('€', '');
				}else{
					this.collegiatPrice = 0.00;
				}

				/* console.log(this.fullPrice);
				console.log(this.intercolPrice);
				console.log(this.collegiatPrice); */

				this.fullPrice = this.parsePriceFloatToString(parseFloat(this.fullPrice));
				this.intercolPrice = this.parsePriceFloatToString(parseFloat(this.intercolPrice)) + "€";
				this.collegiatPrice = this.parsePriceFloatToString(parseFloat(this.collegiatPrice));

				this.fullPrice = this.fullPrice + "€";
				this.intercolPrice = this.intercolPrice + "€";
				this.collegiatPrice = this.collegiatPrice + "€";

				this.finalPrice = this.fullPrice;
			}else{
				this.products.forEach(item => {
					if (item.format == 'p') {
						this.needsPickup = true;
					}
					item['fullPrice'] = this.parsePriceFloatToString(item.price_nc) + "€";
					item['collegiatPrice'] = this.parsePriceFloatToString(item.price_c) + "€";
				});
				//console.log(this.needsPickup)
				this.finalPrice = 0;
				let sum = 0
				this.products.forEach(item => {
					let price = this.parsePriceStringToFloat(item.fullPrice);
					sum = sum + parseFloat(price);
				});
				this.finalPrice = this.parsePriceFloatToString(sum) + "€";
			}
			//this.products = wp_js_var.checkout_products;
			let container = document.querySelector('[data-url-container]');
			//console.log(container);
			this.outputURLComplete = container.dataset['urlSuccess'];
			this.outputURLError = container.dataset['urlError'];

			if (this.parsePriceStringToFloat(this.finalPrice)==0) {
				this.isFree = true;
			}else{
				this.isFree = false;
			}
		},
		methods:{
			updateTab: function(tab){
				this.tab = tab;
				this.calculateFinalPrice();
			},
			calculateFinalPrice: function(){
				let app = this;
				if(app.clientLogged && app.tab == 0){
					//app.finalPrice = app.collegiatPrice;
					app.finalPrice = 0;
					let sum = 0
					app.products.forEach(item => {
						let price;
						price = app.parsePriceStringToFloat(item.collegiatPrice);
						//console.log(sum);
						//console.log(price);
						sum = sum + parseFloat(price);
					});
					//console.log(sum);
					app.finalPrice = app.parsePriceFloatToString(sum) + "€";
				}else{
					//app.finalPrice = app.fullPrice;
					app.finalPrice = 0;
					let sum = 0
					app.products.forEach(item => {
						let price = app.parsePriceStringToFloat(item.fullPrice);
						sum = sum + parseFloat(price);
					});
					app.finalPrice = app.parsePriceFloatToString(sum) + "€";
				}
				if (app.parsePriceStringToFloat(app.finalPrice)==0) {
					app.isFree = true;
				}else{
					app.isFree = false;
				}
			},
			parsePriceStringToFloat: function(string){
				string = String(string);
				let returnString = string.replace('€','');
				returnString.replace('.',',');
				returnString = returnString.replace(',','.');
				return parseFloat(returnString.replace(/[.](?=.*[.])/g, "")).toFixed(2);
			},
			parsePriceFloatToString: function(float){
				let parts = float.toString().split(".");
				const numberPart = parts[0];
				const decimalPart = parts[1];
				const thousands = /\B(?=(\d{3})+(?!\d))/g;
				return numberPart.replace(thousands, ".") + (decimalPart ? "," + decimalPart.substring(0, 2) : ",00");
			},
			updateDiscountedPrice: function(discountApplied){

				this.selectedDiscount = this.discounts[discountApplied];
				this.calculateFinalPrice();
			},
			toggleCompanyLogged: function(event){
				event.preventDefault();
				this.clientLoggedIsCompany = !this.clientLoggedIsCompany;
			},
			toggleCompanyUnlogged: function(event){
				event.preventDefault();
				this.clientUnloggedIsCompany = !this.clientUnloggedIsCompany;
			},
			logClient: function(event){

				event.preventDefault();

				this.loadingLogin = true;
				let app = this;

				this.loginErrors = {
					userNotFound: false,
					passwordError: false
				};
				let url = '/wp-content/themes/cateb/src/services/account/login.php'
					+"?code="+app.loginData.code
					+"&pass="+app.loginData.pass;
				//console.log(url);

				store.dispatch('account/tryLogin', url)

				//store.dispatch('account/forceLogin');
			},
			fillLoggedData: function() {
				let app = this;
				let data = app.sessionInfo;
				app.clientDataLogged.name = data.firstName;
				app.clientDataLogged.surname = data.lastName;
				app.clientDataLogged.documentType = data.documentType;
				app.clientDataLogged.documentNumber = data.documentNumber;
				if (data.mobile) {
					app.clientDataLogged.phone = data.mobile;
				}else if(data.phone){
					app.clientDataLogged.phone = data.phone;
				}else{
					app.clientDataLogged.phone = "";
				}
				app.clientDataLogged.email = data.email;
				app.billingDataLogged.name = data.firstName;
				app.billingDataLogged.surname = data.lastName;
				app.billingDataLogged.documentType = data.documentType;
				app.billingDataLogged.documentNumber = data.documentNumber;
				app.billingDataLogged.address = data.streetType + " " + data.street + " " + data.streetNumber;
				if (data.floor != "-" || data.door != "-" || data.stair) {
					app.billingDataLogged.address = app.billingDataLogged.address + ",";
					if (data.floor != "-") {
						app.billingDataLogged.address = app.billingDataLogged.address + " " + data.floor;
					}
					if (data.door != "-") {
						app.billingDataLogged.address = app.billingDataLogged.address + " " + data.door;
					}
					if (data.stair) {
						app.billingDataLogged.address = app.billingDataLogged.address + " " + data.stair;
					}
				}
				app.billingDataLogged.zipcode = data.postalCode;
				app.billingDataLogged.city = data.city;
				app.billingDataLogged.country = data.country;
				if (!data.isPersonAccount) {
					app.clientDataLogged.companyName = ""
					app.clientDataLogged.companyProfessionalActivity = ""
					app.clientDataLogged.companyProfessionalActivityString = ""
					app.clientDataLogged.companyRole = ""
					app.clientDataLogged.companyRoleString = ""
					app.billingDataLogged.companyName = ""
					app.billingDataLogged.companyCIF = ""
				}
			},
			modifyData: function(block, event){
				event.preventDefault();
				let trigger = event.target;
				let form = trigger.closest('.checkout-form');
				let item = trigger.closest('.c-item-link');
				item.classList.remove('done');
				item.classList.add('edit');
				let itemsList = Array.from(form.querySelectorAll('.c-item-link'));
				let index = itemsList.indexOf(item);
				for (let i = index+1; i < itemsList.length; i++) {
					if(itemsList[i].classList.contains('edit')){
						itemsList[i].classList.remove('edit');
					}
				}
			},
			checkSetData: function(block, event, logged){
				event.preventDefault();
				let app = this;
				let clientData;
				let billingData;
				let clientDataError;
				let billingDataError;
				let clientDataSuccess;
				let billingDataSuccess;
				let clientIsCompany;
				let payerIsCompany;
				let pickupData;
				let pickupDataError;
				let pickupDataSuccess;
				if (logged == 'true') {
					clientData = 'clientDataLogged';
					billingData = 'billingDataLogged';
					clientDataError = 'clientDataLoggedError';
					billingDataError = 'billingDataLoggedError';
					clientDataSuccess = 'clientDataLoggedSuccess';
					billingDataSuccess = 'billingDataLoggedSuccess';
					pickupData = 'pickupDataLogged';
					pickupDataError = 'pickupDataLoggedError';
					pickupDataSuccess = 'pickupDataLoggedSuccess';
					clientIsCompany = this.clientLoggedIsCompany;
					payerIsCompany = this.payerLoggedIsCompany;
				}else{
					clientData = 'clientDataUnlogged';
					billingData = 'billingDataUnlogged';
					clientDataError = 'clientDataUnloggedError';
					billingDataError = 'billingDataUnloggedError';
					clientDataSuccess = 'clientDataUnloggedSuccess';
					billingDataSuccess = 'billingDataUnloggedSuccess';
					pickupData = 'pickupDataUnlogged';
					pickupDataError = 'pickupDataUnloggedError';
					pickupDataSuccess = 'pickupDataUnloggedSuccess';
					clientIsCompany = this.clientUnloggedIsCompany;
					payerIsCompany = this.payerUnloggedIsCompany;
				}
				let trigger = event.target;
				let form = trigger.closest('.checkout-form');
				let item = trigger.closest('.c-item-link');

				let reText = new RegExp("^([a-zA-Z\u00C0-\u017F ]{3,})$");
				let reDocNum;
				let rePhone = new RegExp("^[0-9]{9}$");
				let reEmail = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-]+$");
				let reZipcode = new RegExp("^([0-9]{5})$");

				switch(block){
					case 'personal':
						app[clientDataError].name = false;
						app[clientDataError].surname = false;
						app[clientDataError].documentType = false;
						app[clientDataError].documentNumber = false;
						app[clientDataError].companyName = false;
						app[clientDataError].companyProfessionalActivity = false;
						app[clientDataError].companyRole = false;

						app[clientDataSuccess].name = false;
						app[clientDataSuccess].surname = false;
						app[clientDataSuccess].documentType = false;
						app[clientDataSuccess].documentNumber = false;
						app[clientDataSuccess].companyName = false;
						app[clientDataSuccess].companyProfessionalActivity = false;
						app[clientDataSuccess].companyRole = false;

						if (reText.test(app[clientData].name)) {
							app[clientDataError].name = false;
							app[clientDataSuccess].name = true;
						}else{
							app[clientDataError].name = true;
							app[clientDataSuccess].name = false;
						}
						if (reText.test(app[clientData].surname)) {
							app[clientDataError].surname = false;
							app[clientDataSuccess].surname = true;
						}else{
							app[clientDataError].surname = true;
							app[clientDataSuccess].surname = false;
						}
						if (app[clientData].documentType != "") {
							app[clientDataError].documentType = false;
							app[clientDataSuccess].documentType = true;
						}else{
							app[clientDataError].documentType = true;
							app[clientDataSuccess].documentType = false;
						}
						switch (app[clientData].documentType) {
							case 'NIF':
								reDocNum = new RegExp("^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$");
								break;
							case 'NIE':
								reDocNum = new RegExp("^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$");
								break;
							case 'CIF':
								reDocNum = new RegExp("^([ABCDEFGHJKLMNPQRSUVW])([0-9]{7})([0-9A-J])$");
								break;
							default:
								reDocNum = null;
								break;
						}
						if (reDocNum != null && reDocNum.test(app[clientData].documentNumber)) {
							if (app[clientData].documentType == 'NIF' || app[clientData].documentType == "nie") {
								let value = app[clientData].documentNumber;
								let validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
								let nie = value
									.replace(/^[X]/, '0')
									.replace(/^[Y]/, '1')
									.replace(/^[Z]/, '2');
								let letter = value.substr(-1);
								let charIndex = parseInt(nie.substr(0, 8)) % 23;
								if (validChars.charAt(charIndex) === letter) {
									app[clientDataError].documentNumber = false;
									app[clientDataSuccess].documentNumber = true;
								}else{
									app[clientDataError].documentNumber = true;
									app[clientDataSuccess].documentNumber = false;
								}
							}else if (app[clientData].documentType == "cif"){
								if (this.isValidCif(app[clientData].documentNumber)) {
									app[clientDataError].documentNumber = false;
									app[clientDataSuccess].documentNumber = true;
								}else{
									app[clientDataError].documentNumber = true;
									app[clientDataSuccess].documentNumber = false;
								}
							}
						}else{
							app[clientDataError].documentNumber = true;
							app[clientDataSuccess].documentNumber = false;
						}
						if (clientIsCompany) {
							if (reText.test(app[clientData].companyName)) {
								app[clientDataError].companyName = false;
								app[clientDataSuccess].companyName = true;
							}else{
								app[clientDataError].companyName = true;
								app[clientDataSuccess].companyName = false;
							}
							if (app[clientData].companyProfessionalActivity != "") {
								app[clientDataError].companyProfessionalActivity = false;
								app[clientDataSuccess].companyProfessionalActivity = true;
							}else{
								app[clientDataError].companyProfessionalActivity = true;
								app[clientDataSuccess].companyProfessionalActivity = false;
							}
							if (app[clientData].companyRole != "") {
								app[clientDataError].companyRole = false;
								app[clientDataSuccess].companyRole = true;
							}else{
								app[clientDataError].companyRole = true;
								app[clientDataSuccess].companyRole = false;
							}
						}
						if (
							app[clientDataError].name ||
							app[clientDataError].surname ||
							app[clientDataError].documentType ||
							app[clientDataError].documentNumber ||
							app[clientDataError].companyName ||
							app[clientDataError].companyProfessionalActivity ||
							app[clientDataError].companyRole
						) {
							return;
						}else{
							if (app[billingData].name == "") {
								app[billingData].name = app[clientData].name;
							}
							if (app[billingData].surname == "") {
								app[billingData].surname = app[clientData].surname;
							}
							if (app[billingData].documentType == "") {
								app[billingData].documentType = app[clientData].documentType;
							}
							if (app[billingData].documentNumber == "") {
								app[billingData].documentNumber = app[clientData].documentNumber;
							}
						}
						break;
					case 'contact':
						app[clientDataError].phone = false;
						app[clientDataError].email = false;

						app[clientDataSuccess].phone = false;
						app[clientDataSuccess].email = false;

						if (rePhone.test(app[clientData].phone)) {
							app[clientDataError].phone = false;
							app[clientDataSuccess].phone = true;
						}else{
							app[clientDataError].phone = true;
							app[clientDataSuccess].phone = false;
						}
						if (reEmail.test(app[clientData].email)) {
							app[clientDataError].email = false;
							app[clientDataSuccess].email = true;
						}else{
							app[clientDataError].email = true;
							app[clientDataSuccess].email = false;
						}

						if (app[clientDataError].phone || app[clientDataError].email) {
							return;
						}
						break;
					case 'billing':
						app[billingDataError].name = false;
						app[billingDataError].surname = false;
						app[billingDataError].companyName = false;
						app[billingDataError].documentType = false;
						app[billingDataError].documentNumber = false;
						app[billingDataError].address = false;
						app[billingDataError].zipcode = false;
						app[billingDataError].city = false;
						app[billingDataError].country = false;
						app[billingDataError].companyName = false;
						app[billingDataError].companyCIF = false;

						app[billingDataSuccess].name = false;
						app[billingDataSuccess].surname = false;
						app[billingDataSuccess].documentType = false;
						app[billingDataSuccess].documentNumber = false;
						app[billingDataSuccess].address = false;
						app[billingDataSuccess].zipcode = false;
						app[billingDataSuccess].city = false;
						app[billingDataSuccess].country = false;
						app[billingDataSuccess].companyName = false;
						app[billingDataSuccess].companyCIF = false;
						if (payerIsCompany) {
							if (reText.test(app[billingData].companyName)) {
								app[billingDataError].companyName = false;
								app[billingDataSuccess].companyName = true;
							}else{
								app[billingDataError].companyName = true;
								app[billingDataSuccess].companyName = false;
							}
							let reDocNum = new RegExp("^([ABCDEFGHJKLMNPQRSUVW])([0-9]{7})([0-9A-J])$");
							if (reDocNum.test(app[billingData].companyCIF)) {
								if (this.isValidCif(app[billingData].companyCIF)) {
									app[billingDataError].companyCIF = false;
									app[billingDataSuccess].companyCIF = true;
								}else{
									app[billingDataError].companyCIF = true;
									app[billingDataSuccess].companyCIF = false;
								}
							}else{
								app[billingDataError].companyCIF = true;
								app[billingDataSuccess].companyCIF = false;
							}

						}else{
							if (reText.test(app[billingData].name)) {
								app[billingDataError].name = false;
								app[billingDataSuccess].name = true;
							}else{
								app[billingDataError].name = true;
								app[billingDataSuccess].name = false;
							}
							if (reText.test(app[billingData].surname)) {
								app[billingDataError].surname = false;
								app[billingDataSuccess].surname = true;
							}else{
								app[billingDataError].surname = true;
								app[billingDataSuccess].surname = false;
							}
							if (app[billingData].documentType != "") {
								app[billingDataError].documentType = false;
								app[billingDataSuccess].documentType = true;
							}else{
								app[billingDataError].documentType = true;
								app[billingDataSuccess].documentType = false;
							}
							let reDocNum;
							switch (app[billingData].documentType) {
								case 'NIF':
									reDocNum = new RegExp("^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$");
									break;
								case 'NIE':
									reDocNum = new RegExp("^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$");
									break;
								case 'CIF':
									reDocNum = new RegExp("^([ABCDEFGHJKLMNPQRSUVW])([0-9]{7})([0-9A-J])$");
									break;
								default:
									reDocNum = null;
									break;
							}
							if (reDocNum != null && reDocNum.test(app[billingData].documentNumber)) {
								if (app[billingData].documentType == 'NIF' || app[billingData].documentType == "nie") {
									let value = app[billingData].documentNumber;
									let validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
									let nie = value
										.replace(/^[X]/, '0')
										.replace(/^[Y]/, '1')
										.replace(/^[Z]/, '2');
									let letter = value.substr(-1);
									let charIndex = parseInt(nie.substr(0, 8)) % 23;
									if (validChars.charAt(charIndex) === letter) {
										app[billingDataError].documentNumber = false;
										if(value!=""){
											app[billingDataSuccess].documentNumber = true;
										}
									}else{
										app[billingDataError].documentNumber = true;
										app[billingDataSuccess].documentNumber = false;
									}
								}else if (app[billingData].documentType == "cif"){
									if (this.isValidCif(app[billingData].documentNumber)) {
										app[billingDataError].documentNumber = false;
										app[billingDataSuccess].documentNumber = true;
									}else{
										app[billingDataError].documentNumber = true;
										app[billingDataSuccess].documentNumber = false;
									}
								}
							}else{
								app[billingDataError].documentNumber = true;
								app[billingDataSuccess].documentNumber = false;
							}
						}



						if (app[billingData].address.length > 5) {
							app[billingDataError].address = false;
							app[billingDataSuccess].address = true;
						}else{
							app[billingDataError].address = true;
							app[billingDataSuccess].address = false;
						}
						if (reZipcode.test(app[billingData].zipcode)) {
							app[billingDataError].zipcode = false;
							app[billingDataSuccess].zipcode = true;
						}else{
							app[billingDataError].zipcode = true;
							app[billingDataSuccess].zipcode = false;
						}
						if (reText.test(app[billingData].city)) {
							app[billingDataError].city = false;
							app[billingDataSuccess].city = true;
						}else{
							app[billingDataError].city = true;
							app[billingDataSuccess].city = false;
						}
						if (reText.test(app[billingData].country)) {
							app[billingDataError].country = false;
							app[billingDataSuccess].country = true;
						}else{
							app[billingDataError].country = true;
							app[billingDataSuccess].country = false;
						}


						if (
							app[billingDataError].name ||
							app[billingDataError].surname ||
							app[billingDataError].documentType ||
							app[billingDataError].documentNumber ||
							app[billingDataError].address ||
							app[billingDataError].zipcode ||
							app[billingDataError].city ||
							app[billingDataError].country ||
							app[billingDataError].companyName ||
							app[billingDataError].companyCIF
						) {
							return;
						}

						break;
					case 'pickup':
						app[pickupDataError].location=false;
						app[pickupDataSuccess].location=false;
						if (app[pickupData].location != "") {
							app[pickupDataError].location = false;
							app[pickupDataSuccess].location = true;
						}else{
							app[pickupDataError].location = true;
							app[pickupDataSuccess].location = false;
						}
						if (
							app[pickupDataError].location
						) {
							return;
						}
						break;
					case 'payment':

						break;
					default:

				}
				let itemsList = Array.from(form.querySelectorAll('.c-item-link'));
				let index = itemsList.indexOf(item);
				let nextItem = itemsList[index+1];
				item.classList.remove('edit');
				item.classList.add('done');
				for (let i = index+1; i < itemsList.length; i++) {
					if (!itemsList[i].classList.contains('done') && !itemsList[i].classList.contains('edit')) {
						itemsList[i].classList.add('edit');
						break;
					}
				}

			},
			isValidCif: function(cif) {
				if (!cif || cif.length !== 9) {
					return false;
				}
				let letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
				let digits = cif.substr(1, cif.length - 2);
				let letter = cif.substr(0, 1);
				let control = cif.substr(cif.length - 1);
				let sum = 0;
				let i;
				let digit;
				if (!letter.match(/[A-Z]/)) {
					return false;
				}
				for (i = 0; i < digits.length; ++i) {
					digit = parseInt(digits[i]);
					if (isNaN(digit)) {
						return false;
					}
					if (i % 2 === 0) {
						digit *= 2;
						if (digit > 9) {
							digit = parseInt(digit / 10) + (digit % 10);
						}
						sum += digit;
					} else {
						sum += digit;
					}
				}
				sum %= 10;
				if (sum !== 0) {
					digit = 10 - sum;
				} else {
					digit = sum;
				}
				if (letter.match(/[ABEH]/)) {
					return String(digit) === control;
				}
				if (letter.match(/[NPQRSW]/)) {
					return letters[digit] === control;
				}
				return String(digit) === control || letters[digit] === control;
			},
			finishProcess(event, logged){
				event.preventDefault();
				this.loadingFinal = true;
				let app = this;
				let url = "";
				let redsysDescription = "descripción de muestra";
				if(app.product_type == "course"){
					sessionStorage.setItem('paymentMethod', "0");
					let paymentMethod;
					let discount;
					if (app.selectedDiscount) {
						discount = app.selectedDiscount.discountCode
					}else{
						discount = 0;
					}
					let documentNum;
					let registrationName;
					/* console.log(app.products[0])
					console.log(logged);
					console.log(app.sessionInfo.id); */
					if (logged) {
						documentNum = app.clientDataLogged.documentNumber;
						registrationName = app.clientDataLogged.name + " " + app.clientDataLogged.surname;
						paymentMethod = app.paymentMethodLogged;
						url = '/wp-content/themes/cateb/src/services/checkout/courseInscription.php'
							+"?accountId="+app.sessionInfo.id
							+"&brithdate="+""
							+"&brithPlace="+""
							+"&associateNumber="+""
							+"&bankAccount="+""
							+"&bankDC="+""
							+"&bankEntity="+""
							+"&bankOffice="+""
							+"&bankIBANCode="+""
							+"&city="+app.billingDataLogged.city
							+"&comarca="+""
							+"&Country="+app.billingDataLogged.country
							+"&companyName="+app.clientDataLogged.companyName
							+"&documentNumber="+app.clientDataLogged.documentNumber
							+"&documentType="+app.clientDataLogged.documentType
							+"&email="+app.clientDataLogged.email
							+"&fax="+""
							+"&firstName="+app.clientDataLogged.name
							+"&jobPosition="+""
							+"&lastName="+app.clientDataLogged.surname
							+"&mobile="+app.clientDataLogged.phone
							+"&paymentMethod="+paymentMethod
							+"&personalPhone="+app.clientDataLogged.phone
							+"&phone="+app.clientDataLogged.phone
							+"&postalCode="+app.billingDataLogged.zipcode
							+"&street="+app.billingDataLogged.address
							+"&sex="+""
							+"&courseId="+app.products[0].id
							+"&discount="+ discount
							+"&payerId="+ ""
						if (app.payerLoggedIsCompany) {
							url = url
								+"payerDocumentNumber"+app.billingDataLogged.companyCIF
								+"payerName"+app.billingDataLogged.companyName
								+"payerCity"+app.billingDataLogged.city
								+"payerCountry"+app.billingDataLogged.country
								+"payerPostalCode"+app.billingDataLogged.zipcode
								+"payerStreet"+app.billingDataLogged.address;
						}else if (app.billingDataLogged.documentNumber != app.clientDataLogged.documentNumber) {
							url = url
								+"payerDocumentNumber"+app.billingDataLogged.documentNumber
								+"payerName"+app.billingDataLogged.name+" "+app.billingDataLogged.surname
								+"payerCity"+app.billingDataLogged.city
								+"payerCountry"+app.billingDataLogged.country
								+"payerPostalCode"+app.billingDataLogged.zipcode
								+"payerStreet"+app.billingDataLogged.address;
						}
					}else{
						paymentMethod = app.paymentMethodUnlogged;
						documentNum = app.clientDataUnlogged.documentNumber;
						registrationName = app.clientDataUnlogged.name + " " + app.clientDataUnlogged.surname;
						url = '/wp-content/themes/cateb/src/services/checkout/courseInscription.php'
							+"?accountId="+""
							+"&birthdate="+""
							+"&birthPlace="+""
							+"&associateNumber="+""
							+"&bankAccount="+""
							+"&bankDC="+""
							+"&bankEntity="+""
							+"&bankOffice="+""
							+"&bankIBANCode="+""
							+"&city="+app.billingDataUnlogged.city
							+"&comarca="+""
							+"&Country="+app.billingDataUnlogged.country
							+"&companyName="+app.clientDataUnlogged.companyName
							+"&documentNumber="+app.clientDataUnlogged.documentNumber
							+"&documentType="+app.clientDataUnlogged.documentType
							+"&email="+app.clientDataUnlogged.email
							+"&fax="+""
							+"&firstName="+app.clientDataUnlogged.name
							+"&jobPosition="+""
							+"&lastName="+app.clientDataUnlogged.surname
							+"&mobile="+app.clientDataUnlogged.phone
							+"&paymentMethod="+paymentMethod
							+"&personalPhone="+app.clientDataUnlogged.phone
							+"&phone="+app.clientDataUnlogged.phone
							+"&postalCode="+app.billingDataUnlogged.zipcode
							+"&street="+app.billingDataUnlogged.address
							+"&sex="+""
							+"&courseId="+app.products[0].id
							+"&discount="+ discount
							+"&payerId="+ "";
						if (app.payerUnloggedIsCompany) {
							url = url
								+"payerDocumentNumber"+app.billingDataUnlogged.companyCIF
								+"payerName"+app.billingDataUnlogged.companyName
								+"payerCity"+app.billingDataUnlogged.city
								+"payerCountry"+app.billingDataUnlogged.country
								+"payerPostalCode"+app.billingDataUnlogged.zipcode
								+"payerStreet"+app.billingDataUnlogged.address;
						}else if (app.billingDataUnlogged.documentNumber != app.clientDataUnlogged.documentNumber) {
							url = url
								+"payerDocumentNumber"+app.billingDataUnlogged.documentNumber
								+"payerName"+app.billingDataUnlogged.name+" "+app.billingDataUnlogged.surname
								+"payerCity"+app.billingDataUnlogged.city
								+"payerCountry"+app.billingDataUnlogged.country
								+"payerPostalCode"+app.billingDataUnlogged.zipcode
								+"payerStreet"+app.billingDataUnlogged.address;
						}
					}
					//inscription
					//console.log(url);
					sendPetition(url, (data)=>{
						//console.log(data)
						if (data.result.statusCode == 200) {
							sessionStorage.setItem('paymentMethod', paymentMethod);
							//console.log(data.registrationId)
							sessionStorage.setItem('registrationId', data.registrationId);
							if (paymentMethod === "J") {
								let facturaUrl = "/wp-content/themes/cateb/src/services/checkout/paymentRequest.php"
									+"?registrationId="+data.registrationId
									+"&descripcion="+redsysDescription
									+"&titular="+registrationName
									+"&nif="+documentNum
									+"&urlresponse="+encodeURIComponent(app.outputURLComplete)
									+"&urlresponseint="+encodeURIComponent(app.outputURLError)
									+"&purchaseType="+"course";
								//console.log(facturaUrl);
								//console.log('/wp-content/themes/cateb/src/services/checkout/paymentRequest.php');
								sendPetition(facturaUrl, (newData)=>{
									//console.log(newData);
									//console.log(newData.pagoVisaResult)
									if (newData.pagoVisaResult) {
										this.loadingFinal = false;
										let pagoVisaResult = newData.pagoVisaResult;
										let pagoVisaResult_aux = pagoVisaResult.replace("<![CDATA[", "");
										pagoVisaResult_aux = pagoVisaResult_aux.replace("]]>", "");
										let form_container = new DOMParser().parseFromString(pagoVisaResult_aux, "text/html");
										let form = form_container.querySelector('form');
										document.body.appendChild(form)
										let formDOM = document.body.querySelector("form[name='form1']");
										formDOM.submit();
									}else{
										this.loadingFinal = false;
										window.location = app.outputURLError;
									}
								})
							}else{
								app.checkoutComplete = true;
								this.loadingFinal = false;
								window.location = app.outputURLComplete;
							}
						}else if(data.result.statusCode == 405){
							//console.log(sessionStorage.getItem('checkoutProductsType'));
							//console.log(app.products);
							this.loadingFinal = false;
							sessionStorage.setItem('errorCode', 405);
							window.location = app.outputURLError;
						}else if(data.result.statusCode == 201){
							//console.log(sessionStorage.getItem('checkoutProductsType'));
							//console.log(app.products);
							this.loadingFinal = false;
							sessionStorage.setItem('errorCode', 201);
							window.location = app.outputURLError;
						}else{
							this.loadingFinal = false;
							//console.log(data.result)
							window.location = app.outputURLError;
						}
					});
				}else if(app.product_type == "activity"){
					sessionStorage.setItem('paymentMethod', "0");
					let paymentMethod;
					let documentNum;
					let registrationName;

					if (logged) {
						documentNum = app.clientDataLogged.documentNumber;
						registrationName = app.clientDataLogged.name + " " + app.clientDataLogged.surname;
						paymentMethod = app.paymentMethodLogged;
						if (app.isFree) {
							paymentMethod = "J";
						}
						url = '/wp-content/themes/cateb/src/services/checkout/activityInscription.php'
							+"?accountId="+app.sessionInfo.id
							+"&brithdate="+""
							+"&brithPlace="+""
							+"&associateNumber="+""
							+"&bankAccount="+""
							+"&bankDC="+""
							+"&bankEntity="+""
							+"&bankOffice="+""
							+"&bankIBANCode="+""
							+"&city="+app.billingDataLogged.city
							+"&comarca="+""
							+"&Country="+app.billingDataLogged.country
							+"&companyName="+app.clientDataLogged.companyName
							+"&documentNumber="+app.clientDataLogged.documentNumber
							+"&documentType="+app.clientDataLogged.documentType
							+"&email="+app.clientDataLogged.email
							+"&fax="+""
							+"&firstName="+app.clientDataLogged.name
							+"&jobPosition="+""
							+"&lastName="+app.clientDataLogged.surname
							+"&mobile="+app.clientDataLogged.phone
							+"&paymentMethod="+paymentMethod
							+"&personalPhone="+app.clientDataLogged.phone
							+"&phone="+app.clientDataLogged.phone
							+"&postalCode="+app.billingDataLogged.zipcode
							+"&street="+app.billingDataLogged.address
							+"&sex="+""
							+"&activityId="+app.products[0].id
							+"&adults="+1
							+"&children="+0
							+"&payerId="+ ""
						if (app.payerLoggedIsCompany) {
							url = url
								+"payerDocumentNumber"+app.billingDataLogged.companyCIF
								+"payerName"+app.billingDataLogged.companyName
								+"payerCity"+app.billingDataLogged.city
								+"payerCountry"+app.billingDataLogged.country
								+"payerPostalCode"+app.billingDataLogged.zipcode
								+"payerStreet"+app.billingDataLogged.address;
						}else if (app.billingDataLogged.documentNumber != app.clientDataLogged.documentNumber) {
							url = url
								+"payerDocumentNumber"+app.billingDataLogged.documentNumber
								+"payerName"+app.billingDataLogged.name+" "+app.billingDataLogged.surname
								+"payerCity"+app.billingDataLogged.city
								+"payerCountry"+app.billingDataLogged.country
								+"payerPostalCode"+app.billingDataLogged.zipcode
								+"payerStreet"+app.billingDataLogged.address;
						}
					}else{
						paymentMethod = app.paymentMethodUnlogged;
						if (app.isFree) {
							paymentMethod = "J";
						}
						documentNum = app.clientDataUnlogged.documentNumber;
						registrationName = app.clientDataUnlogged.name + " " + app.clientDataUnlogged.surname;
						url = '/wp-content/themes/cateb/src/services/checkout/activityInscription.php'
							+"?accountId="+""
							+"&birthdate="+""
							+"&birthPlace="+""
							+"&associateNumber="+""
							+"&bankAccount="+""
							+"&bankDC="+""
							+"&bankEntity="+""
							+"&bankOffice="+""
							+"&bankIBANCode="+""
							+"&city="+app.billingDataUnlogged.city
							+"&comarca="+""
							+"&Country="+app.billingDataUnlogged.country
							+"&companyName="+app.clientDataUnlogged.companyName
							+"&documentNumber="+app.clientDataUnlogged.documentNumber
							+"&documentType="+app.clientDataUnlogged.documentType
							+"&email="+app.clientDataUnlogged.email
							+"&fax="+""
							+"&firstName="+app.clientDataUnlogged.name
							+"&jobPosition="+""
							+"&lastName="+app.clientDataUnlogged.surname
							+"&mobile="+app.clientDataUnlogged.phone
							+"&paymentMethod="+paymentMethod
							+"&personalPhone="+app.clientDataUnlogged.phone
							+"&phone="+app.clientDataUnlogged.phone
							+"&postalCode="+app.billingDataUnlogged.zipcode
							+"&street="+app.billingDataUnlogged.address
							+"&sex="+""
							+"&activityId="+app.products[0].id
							+"&adults="+1
							+"&children="+0
							+"&payerId="+ "";
						if (app.payerUnloggedIsCompany) {
							url = url
								+"payerDocumentNumber"+app.billingDataUnlogged.companyCIF
								+"payerName"+app.billingDataUnlogged.companyName
								+"payerCity"+app.billingDataUnlogged.city
								+"payerCountry"+app.billingDataUnlogged.country
								+"payerPostalCode"+app.billingDataUnlogged.zipcode
								+"payerStreet"+app.billingDataUnlogged.address;
						}else if (app.billingDataUnlogged.documentNumber != app.clientDataUnlogged.documentNumber) {
							url = url
								+"payerDocumentNumber"+app.billingDataUnlogged.documentNumber
								+"payerName"+app.billingDataUnlogged.name+" "+app.billingDataUnlogged.surname
								+"payerCity"+app.billingDataUnlogged.city
								+"payerCountry"+app.billingDataUnlogged.country
								+"payerPostalCode"+app.billingDataUnlogged.zipcode
								+"payerStreet"+app.billingDataUnlogged.address;
						}
					}
					//inscription

					//console.log(url)
					sendPetition(url, (data)=>{
						//console.log(data)
						if (data.result.statusCode == 200) {
							sessionStorage.setItem('paymentMethod', paymentMethod);
							//console.log(data.inscriptionId)
							sessionStorage.setItem('inscriptionId', data.inscriptionId);
							if (app.isFree) {
								app.checkoutComplete = true;
								this.loadingFinal = false;
								window.location = app.outputURLComplete;
							}else{
								if (paymentMethod === "J") {
									let facturaUrl = "/wp-content/themes/cateb/src/services/checkout/paymentRequest.php"
										+"?registrationId="+data.inscriptionId
										+"&descripcion="+redsysDescription
										+"&titular="+registrationName
										+"&nif="+documentNum
										+"&urlresponse="+encodeURIComponent(app.outputURLComplete)
										+"&urlresponseint="+encodeURIComponent(app.outputURLError)
										+"&purchaseType="+"activity";
									//console.log(facturaUrl);
									sendPetition(facturaUrl, (newData)=>{
										//console.log(newData);
										if (newData.pagoVisaResult) {
											this.loadingFinal = false;
											let pagoVisaResult = newData.pagoVisaResult;
											let pagoVisaResult_aux = pagoVisaResult.replace("<![CDATA[", "");
											pagoVisaResult_aux = pagoVisaResult_aux.replace("]]>", "");
											let form_container = new DOMParser().parseFromString(pagoVisaResult_aux, "text/html");
											let form = form_container.querySelector('form');
											document.body.appendChild(form)
											let formDOM = document.body.querySelector("form[name='form1']");
											formDOM.submit();
										}else{
											this.loadingFinal = false;
											//console.log(data)
											window.location = app.outputURLError;
										}
									})
								}else{
									this.loadingFinal = false;
									app.checkoutComplete = true;
									window.location = app.outputURLComplete;
								}
							}

						}else if(data.result.statusCode == 405){
							this.loadingFinal = false;
							sessionStorage.setItem('errorCode', 405);
							window.location = app.outputURLError;
						}else if(data.result.statusCode == 201){
							this.loadingFinal = false;
							sessionStorage.setItem('errorCode', 201);
							window.location = app.outputURLError;
						}else{
							this.loadingFinal = false;
							//console.log(data)
							window.location = app.outputURLError;
						}
					});
				}else{
					sessionStorage.setItem('paymentMethod', "0");
					let paymentMethod;
					let pickupLocation;
					url = "";
					let productPurchaseList = [];
					app.products.forEach(prod=>{
						if (productPurchaseList.find(checkedProd => checkedProd.code == prod.sapCode)) {
							productPurchaseList.find(checkedProd => checkedProd.code == prod.sapCode).quantity ++;
						}else{
							productPurchaseList.push({code: prod.sapCode, quantity: 1})
						}
					});
					/* console.log(app.outputURLComplete);
					console.log(encodeURI(app.outputURLComplete));
					console.log(encodeURIComponent(app.outputURLComplete)); */
					if (logged) {
						paymentMethod = app.paymentMethodLogged;
						pickupLocation = app.pickupDataLogged.location;
						url = '/wp-content/themes/cateb/src/services/checkout/bookPurchaseLogged.php'
							+"?accountId="+app.sessionInfo.id
							+"&payerId="+""
							+"&paymentMethod="+app.paymentMethodLogged
							+"&products="+JSON.stringify(productPurchaseList)
							+"&descripcion="+redsysDescription
							+"&titular="+encodeURIComponent(app.clientDataLogged.name+" "+app.clientDataLogged.surname)
							+"&nif="+app.clientDataLogged.documentNumber
							+"&urlresponse="+encodeURIComponent(app.outputURLComplete)
							+"&urlresponseint="+encodeURIComponent(app.outputURLError)
							+"&pickupLocation="+encodeURIComponent(app.pickupDataLogged.location)
							+"&downloadUrl="+"";
							if (app.payerLoggedIsCompany) {
								url = url
									+"payerDocumentNumber"+app.billingDataLogged.companyCIF
									+"payerName"+encodeURIComponent(app.billingDataLogged.companyName)
									+"payerCity"+encodeURIComponent(app.billingDataLogged.city)
									+"payerCountry"+encodeURIComponent(app.billingDataLogged.country)
									+"payerPostalCode"+app.billingDataLogged.zipcode
									+"payerStreet"+encodeURIComponent(app.billingDataLogged.address);
							}else if (app.billingDataLogged.documentNumber != app.clientDataLogged.documentNumber) {
								url = url
									+"payerDocumentNumber"+app.billingDataLogged.documentNumber
									+"payerName"+encodeURIComponent(app.billingDataLogged.name+" "+app.billingDataLogged.surname)
									+"payerCity"+encodeURIComponent(app.billingDataLogged.city)
									+"payerCountry"+encodeURIComponent(app.billingDataLogged.country)
									+"payerPostalCode"+encodeURIComponent(app.billingDataLogged.zipcode)
									+"payerStreet"+encodeURIComponent(app.billingDataLogged.address);
							}
					}else{
						paymentMethod = app.paymentMethodUnlogged;
						pickupLocation = app.pickupDataUnlogged.location;
						url = '/wp-content/themes/cateb/src/services/checkout/bookPurchaseUnlogged.php'
							+"?accountId="+""
							+"&payerId="+""
							+"&birthdate="+""
							+"&birthPlace="+""
							+"&associateNumber="+""
							+"&bankAccount="+""
							+"&bankDC="+""
							+"&bankEntity="+""
							+"&bankOffice="+""
							+"&bankIBANCode="+""
							+"&city="+app.billingDataUnlogged.city
							+"&Country="+app.billingDataUnlogged.country
							+"&companyName="+app.clientDataUnlogged.companyName
							+"&documentNumber="+app.clientDataUnlogged.documentNumber
							+"&documentType="+app.clientDataUnlogged.documentType
							+"&email="+app.clientDataUnlogged.email
							+"&fax="+""
							+"&firstName="+app.clientDataUnlogged.name
							+"&jobPosition="+""
							+"&lastName="+app.clientDataUnlogged.surname
							+"&mobile="+""
							+"&personalPhone="+""
							+"&phone="+app.clientDataUnlogged.phone
							+"&postalCode="+app.billingDataUnlogged.zipcode
							+"&street="+app.billingDataUnlogged.address
							+"&sex="+""
							+"&paymentMethod="+app.paymentMethodUnlogged
							+"&products="+JSON.stringify(productPurchaseList)
							+"&descripcion="+redsysDescription
							+"&titular="+app.clientDataUnlogged.name+" "+app.clientDataUnlogged.surname
							+"&nif="+app.clientDataUnlogged.documentNumber
							+"&urlresponse="+encodeURIComponent(app.outputURLComplete)
							+"&urlresponseint="+encodeURIComponent(app.outputURLError)
							+"&pickupLocation="+app.pickupDataUnlogged.location
							+"&downloadUrl="+"";

						if (app.payerUnloggedIsCompany) {
							url = url
								+"payerDocumentNumber"+app.billingDataUnlogged.companyCIF
								+"payerName"+app.billingDataUnlogged.companyName
								+"payerCity"+app.billingDataUnlogged.city
								+"payerCountry"+app.billingDataUnlogged.country
								+"payerPostalCode"+app.billingDataUnlogged.zipcode
								+"payerStreet"+app.billingDataUnlogged.address;
						}else if (app.billingDataUnlogged.documentNumber != app.clientDataUnlogged.documentNumber) {
							url = url
								+"payerDocumentNumber"+app.billingDataUnlogged.documentNumber
								+"payerName"+app.billingDataUnlogged.name+" "+app.billingDataUnlogged.surname
								+"payerCity"+app.billingDataUnlogged.city
								+"payerCountry"+app.billingDataUnlogged.country
								+"payerPostalCode"+app.billingDataUnlogged.zipcode
								+"payerStreet"+app.billingDataUnlogged.address;
						}
					}
					//console.log(url);
					//factura

					if (app.isFree) {
						paymentMethod = "0";
					}
					sendPetition(url, (data)=>{
						//console.log(data);
						if (data.result.statusCode == 200) {
							let pagoVisaResult;
							sessionStorage.setItem('paymentMethod', paymentMethod);
							sessionStorage.setItem('idFactura', data.idFactura);
							sessionStorage.setItem('pickupLocation', pickupLocation);
							if (app.isFree) {
								app.checkoutComplete = true;
								this.loadingFinal = false;
								window.location = app.outputURLComplete;
							}else{
								if (paymentMethod === "J") {
									pagoVisaResult = data.pagoVisaResult;
									let pagoVisaResult_aux = pagoVisaResult.replace("<![CDATA[", "");
									pagoVisaResult_aux = pagoVisaResult_aux.replace("]]>", "");
									let form_container = new DOMParser().parseFromString(pagoVisaResult_aux, "text/html");
									let form = form_container.querySelector('form');
									document.body.appendChild(form)
									let formDOM = document.body.querySelector("form[name='form1']");
									this.loadingFinal = false;
									formDOM.submit();
								}else{
									app.checkoutComplete = true;
									this.loadingFinal = false;
									//set parameters of results page
									window.location = app.outputURLComplete;
								}
							}
						}else{
							this.loadingFinal = false;
							window.location = app.outputURLError;
						}
					});
				}
			},
			loginBtnEnabled: function(){
				if (this.loginData.code == "" || this.loginData.pass == "") {
					return 'c-btn--disabled';
				}else{
					return '';
				}
			},
			personalDataLoggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (this.clientLoggedIsCompany) {
					if (
						this.clientDataLogged.name != "" &&
						this.clientDataLogged.surname != "" &&
						this.clientDataLogged.documentNumber != "" &&
						this.clientDataLogged.documentType != "" &&
						this.clientDataLogged.companyName != "" &&
						this.clientDataLogged.companyProfessionalActivity != "" &&
						this.clientDataLogged.companyRole != ""
					) {
						returnVal = '';
					}else{
						returnVal = 'c-btn--disabled';
					}
				}else{
					if (
						this.clientDataLogged.name != "" &&
						this.clientDataLogged.surname != "" &&
						this.clientDataLogged.documentNumber != "" &&
						this.clientDataLogged.documentType!= ""
					) {
						returnVal = '';
					}else{
						returnVal = 'c-btn--disabled';
					}
				}
				return returnVal;
			},
			contactDataLoggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (
					this.clientDataLogged.phone != "" &&
					this.clientDataLogged.email != ""
				) {
					returnVal = '';
				}else{
					returnVal = 'c-btn--disabled';
				}
				return returnVal;
			},
			billingDataLoggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (this.payerLoggedIsCompany) {
					if (
						this.billingDataLogged.companyName != "" &&
						this.billingDataLogged.companyCIF != "" &&
						this.billingDataLogged.address!= "" &&
						this.billingDataLogged.zipcode!= "" &&
						this.billingDataLogged.city!= "" &&
						this.billingDataLogged.country!= ""
					) {
						returnVal = '';
					}else{
						returnVal = 'c-btn--disabled';
					}
				}else{
					if (
						this.billingDataLogged.name != "" &&
						this.billingDataLogged.surname != "" &&
						this.billingDataLogged.documentNumber != "" &&
						this.billingDataLogged.documentType!= "" &&
						this.billingDataLogged.address!= "" &&
						this.billingDataLogged.zipcode!= "" &&
						this.billingDataLogged.city!= "" &&
						this.billingDataLogged.country!= ""
					) {
						returnVal = '';
					}else{
						returnVal = 'c-btn--disabled';
					}
				}

				return returnVal;
			},
			pickupDataLoggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (
					this.pickupDataLogged.location != ""
				) {
					returnVal = '';
				}else{
					returnVal = 'c-btn--disabled';
				}

				return returnVal;
			},
			paymentLoggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (
					this.conditionsCheckedLogged
				) {
					returnVal = '';
				}else{
					returnVal = 'c-btn--disabled';
				}

				return returnVal;
			},
			personalDataUnloggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (this.clientUnloggedIsCompany) {
					if (
						this.clientDataUnlogged.name != "" &&
						this.clientDataUnlogged.surname != "" &&
						this.clientDataUnlogged.documentNumber != "" &&
						this.clientDataUnlogged.documentType != "" &&
						this.clientDataUnlogged.companyName != "" &&
						this.clientDataUnlogged.companyProfessionalActivity != "" &&
						this.clientDataUnlogged.companyRole != ""
					) {
						returnVal = '';
					}else{
						returnVal = 'c-btn--disabled';
					}
				}else{
					if (
						this.clientDataUnlogged.name != "" &&
						this.clientDataUnlogged.surname != "" &&
						this.clientDataUnlogged.documentNumber != "" &&
						this.clientDataUnlogged.documentType!= ""
					) {
						returnVal = '';
					}else{
						returnVal = 'c-btn--disabled';
					}
				}
				return returnVal;
			},
			contactDataUnloggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (
					this.clientDataUnlogged.name != "" &&
					this.clientDataUnlogged.surname != "" &&
					this.clientDataUnlogged.documentNumber != "" &&
					this.clientDataUnlogged.documentType!= ""
				) {
					returnVal = '';
				}else{
					returnVal = 'c-btn--disabled';
				}
				return returnVal;
			},
			billingDataUnloggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (this.payerUnloggedIsCompany) {
					if (
						this.billingDataUnlogged.companyName != "" &&
						this.billingDataUnlogged.companyCIF != "" &&
						this.billingDataUnlogged.address!= "" &&
						this.billingDataUnlogged.zipcode!= "" &&
						this.billingDataUnlogged.city!= "" &&
						this.billingDataUnlogged.country!= ""
					) {
						returnVal = '';
					}else{
						returnVal = 'c-btn--disabled';
					}
				}else{
					if (
						this.billingDataUnlogged.name != "" &&
						this.billingDataUnlogged.surname != "" &&
						this.billingDataUnlogged.documentNumber != "" &&
						this.billingDataUnlogged.documentType!= "" &&
						this.billingDataUnlogged.address!= "" &&
						this.billingDataUnlogged.zipcode!= "" &&
						this.billingDataUnlogged.city!= "" &&
						this.billingDataUnlogged.country!= ""
					) {
						returnVal = '';
					}else{
						returnVal = 'c-btn--disabled';
					}
				}

				return returnVal;
			},
			pickupDataUnloggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (
					this.pickupDataUnlogged.location != ""
				) {
					returnVal = '';
				}else{
					returnVal = 'c-btn--disabled';
				}

				return returnVal;
			},
			paymentUnloggedBtnEnabled: function(){
				let returnVal = "c-btn--disabled";
				if (
					this.conditionsCheckedUnlogged
				) {
					returnVal = '';
				}else{
					returnVal = 'c-btn--disabled';
				}

				return returnVal;
			},
			updateBillingForm: function(event, logged){
				let data = event.target.value;
				if (logged == "true") {
					if (data == "true") {
						this.payerLoggedIsCompany = true;
						this.billingDataLogged.name = "";
						this.billingDataLogged.surname = "";
						this.billingDataLogged.documentType = "";
						this.billingDataLogged.documentNumber = "";
					}else{
						this.payerLoggedIsCompany = false;
						this.billingDataLogged.name = this.clientDataLogged.name;
						this.billingDataLogged.surname = this.clientDataLogged.surname;
						this.billingDataLogged.documentType = this.clientDataLogged.documentType;
						this.billingDataLogged.documentNumber = this.clientDataLogged.documentNumber;
					}
				}else{
					if (data == "true") {
						this.payerUnloggedIsCompany = true;
						this.billingDataUnlogged.name = "";
						this.billingDataUnlogged.surname = "";
						this.billingDataUnlogged.documentType = "";
						this.billingDataUnlogged.documentNumber = "";
					}else{
						this.payerUnloggedIsCompany = false;
						this.billingDataUnlogged.name = this.clientDataUnlogged.name;
						this.billingDataUnlogged.surname = this.clientDataUnlogged.surname;
						this.billingDataUnlogged.documentType = this.clientDataUnlogged.documentType;
						this.billingDataUnlogged.documentNumber = this.clientDataUnlogged.documentNumber;
					}
				}
			},
			setSelectString: function(e, code, block, string, logged){
				let app = this;
				switch (block) {
					case 'clientData':
						if (logged) {
							app.clientDataLogged[string] = e.currentTarget.options[e.currentTarget.selectedIndex].text;
						}else{
							app.clientDataUnlogged[string] = e.currentTarget.options[e.currentTarget.selectedIndex].text;
						}
						break;
					case 'billingData':
						if (logged) {
							app.billingDataLogged[string] = e.currentTarget.options[e.currentTarget.selectedIndex].text;
						}else{
							app.billingDataUnlogged[string] = e.currentTarget.options[e.currentTarget.selectedIndex].text;
						}
						break;
				}
			}
		}
	}).mount(document.querySelector('.p-checkout-module'));
}
